import React from 'react';
import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";

function ListCellZ({ text, icon, onClick, selected }) {
  return (
    <div className={`list-cell clickable ${selected && "selected"}`} onClick={onClick}>
      <SvgIcn name={icon} className="icon-left" />
      {text && <span>{text}</span>}
      <SvgIcn name="small_arrow" className="icon-right" />
    </div>
  );
}

export default ListCellZ;
